import { normalizeSportsbookId, sportsbookIdToDisplay, type SportsbookId } from "@/lib/sportsbook-registry";
import type { FantasyScoringMetadata, MarketType, SelectionSide } from "@/types/evbook";
import type { BetLinkSet } from "@/lib/bet-links";
export const SUPPORTED_LEAGUES = [
  "NBA",
  "NCAAB",
  "NCAAW",
  "NFL",
  "CFB",
  "MLB",
  "CBB",
  "WNBA",
  "UFC",
  "TENNIS",
  "SOCCER",
  "GOLF",
];

export const WEIGHTS_BY_SPORTSBOOK_NAME = {
  fanduel: 0.4,
  draftkings: 0.35,
  caesars: 0.15,
  betmgm: 0.07,
  hardrock: 0.05,
  fanatics: 0.02,
  betr: 0.05,
  novig: 0.05,
  prophetx: 0.05,
  dabble: 0.05,
  dkpick6: 0.05,
  circa: 0.05,
  pinnacle: 0.05,
  kalshi: 0.05,
  polymarket: 0.05,
  rebet: 0.05,
  kambi: 0.05,
  parlayplay: 0.05,
  tailgate: 0.05,
};

export function normalizeFantasySportsbookId(
  raw: string | null | undefined,
): string {
  return normalizeSportsbookId(raw) || "";
}

export interface ComparisonOddsEntry {
  american_odds: number | null;
  line?: number | null;
  normalized_line?: number | null;
  normalized_line_basis?: string | null;
  selection_side?: "OVER" | "UNDER" | string | null;
  fantasy_scoring?: FantasyScoringMetadata | null;
}

export type ComparisonOddsMap = Record<string, ComparisonOddsEntry>;

export interface OptimizerResult {
  id?: string;

  sport: string;
  league?: string | null;
  game_id: number;
  player_id: number;
  player_name: string;
  team: string | null;
  opponent: string | null;
  game_start_time: string | null;
  event?: string | null;
  event_short?: string | null;
  team_short?: string | null;
  opponent_short?: string | null;
  player_position?: string | null;
  player_image_url?: string | null;
  event_start?: string | null;
  event_id?: string | null;
  entity_key?: string | null;
  selection_id?: string | null;
  opp_selection_id?: string | null;

  stat_type: string;
  line: number;
  over_under: string;
  market?: string | null;
  market_type?: MarketType | null;
  market_display?: string | null;
  selection?: string | null;
  selection_side?: SelectionSide | null;
  selectionSide?: SelectionSide | null;

  fantasy_sportsbook: string;
  fantasy_american_odds: number | null;
  fantasy_implied_probability: number | null;
  opp_american_odds?: number | null;
  fantasy_sportsbook_group?: string | null;
  sportsbook?: string | null;
  sportsbook_american_odds?: number | null;

  consensus_implied_probability: number;
  ev_percentage: number;
  odds_to_hit_percentage: number;
  ev_roi?: number | null;
  fair_implied_probability?: number | null;
  pairing_key?: string | null;
  opposing_book?: string | null;

  sportsbook_odds: Record<string, SportsbookOddsPair>;
  sportsbook_liquidity?: Record<string, SportsbookLiquidityPair>;
  sportsbook_group?: string | null;
  multiplier?: number | null;
  bucket?: number | null;
  comparison_odds?: ComparisonOddsMap;
  comparison_bet_links?: Record<string, BetLinkSet>;
  comparison_selection_ids?: Record<string, string>;
  fantasy_scoring?: FantasyScoringMetadata | null;
  comparison_fantasy_scoring?: Record<string, FantasyScoringMetadata | null>;

  peer_book_count?: number | null;

  bet_link?: string | null;

  created_at?: string;
  updated_at?: string;
  processing_batch: string | null;
}

export interface SportsbookOddsPair {
  over: number | null;
  under: number | null;
  line?: number | null;
  normalized_line?: number | null;
  normalized_line_basis?: string | null;
  fantasy_scoring?: FantasyScoringMetadata | null;
}

export interface SportsbookLiquidityPair {
  over: number | null;
  under: number | null;
}
